import {
  Button,
  Dialog,
  Heading,
  InboxIcon,
  Pane,
  Select,
  Spinner,
  Strong,
  Switch,
  Text,
  TextInputField,
  toaster,
} from "evergreen-ui";
import React, { Component } from "react";

import { connect } from "react-redux";
import BackBar from "../components/backBar";
import BookingDetailsDialog from "../components/bookingDetailsDialog";
import CustomBookingCard from "../components/SearchBooking/CustomBookingCard";

import {
  bookingCheckIn,
  getBooking,
  getCategoriesList,
  getEventBookingList,
  getEvents,
} from "../external/actions";

class Event extends Component {
  constructor(props) {
    super(props);
    this.state = {
      eventList: [],
      showPage: false,
      categoryList: [],
      eventName: "Select Event",
      defaultEventName: "Select Event",
      defaultEventId: "select-event",
      defaultCategoryName: "Select Category",
      defaultCategoryId: "select-category",
      eventId: "",
      categoryId: "",
      categoryName: "Select Category",
      pageNo: 1,
      eventBookingList: null,
      nextPage: 0,
      totalPage: 0,
      bookingLoader: false,
      loader: false,
      showBookingDetailsDialog: false,
      bookingDetails: "",
      bookingDetailsIndex: null,
      bookingStatusIntentMap: {
        upcoming: "green",
        completed: "orange",
        ongoing: "blue",
        cancelled: "red",
      },
    };
  }

  componentDidMount() {
    window.addEventListener("scroll", this.onScroll, false);
    getEvents().then((data) => {
      if (data.requestStatus === 1) {
        this.setState({
          eventList: data.eventList,
          showPage: true,
        });
      } else if (data.requestStatus === -1) {
        this.setState({
          showPage: false,
        });
        toaster.warning("You Dont Have Permission");
      } else {
        this.setState({
          showPage: false,
        });
        toaster.warning(data?.message);
      }
    });
  }

  showBookingDialog = async (status) => {
    this.setState({
      showBookingDetailsDialog: status,
    });
  };

  componentWillUnmount() {
    window.removeEventListener("scroll", this.onScroll, false);
  }

  onScroll = async () => {
    const {
      loader,
      eventBookingList,
      nextPage,
      eventId,
      value,
      pageNo,
      categoryId,
    } = this.state;

    const scrollTop =
      (document.documentElement && document.documentElement.scrollTop) ||
      document.body.scrollTop;
    const scrollHeight =
      (document.documentElement && document.documentElement.scrollHeight) ||
      document.body.scrollHeight;
    const clientHeight =
      document.documentElement.clientHeight || window.innerHeight;
    const scrolledToBottom =
      Math.ceil(scrollTop + clientHeight) >= scrollHeight;

    if (scrolledToBottom && nextPage && nextPage !== -1 && !loader) {
      this.getBooking(eventId, categoryId, nextPage, eventBookingList);
      this.setState({ pageNo: nextPage });
    }
  };

  showBookingDetailsDialog = async (details, index) => {
    await this.setState({
      bookingDetails: details,
      bookingDetailsIndex: index,
    });
    await this.showBookingDialog(true);
  };

  getCategoriesByEventId = (e) => {
    let value = e.target.value;
    let name =
      e.nativeEvent.target[e.nativeEvent.target.selectedIndex].text.toString();

    if (value === "select-event") {
      toaster.notify("select an event");
    } else {
      getCategoriesList(value).then((data) => {
        this.setState({
          eventName: name,
          eventId: value,
          categoryList: data.categoryList,
          categoryId: "",
          categoryName: "Select Category",
          pageNo: 1,
          eventBookingList: null,
        });
      });
    }
  };

  getEventBooking = (e) => {
    let { categoryList } = this.state;
    let value = e.target.value;

    let name =
      e.nativeEvent.target[e.nativeEvent.target.selectedIndex].text.toString();

    if (value === "select-category") {
      toaster.notify("select a category");
    } else {
      this.setState({ pageNo: 1 });
      let { eventId } = this.state;

      this.getBooking(eventId, value, 1);
    }
  };

  getBooking = (eventId, categoryId, page, previousSearchData = []) => {
    this.setState({ bookingLoader: true });

    getEventBookingList({ eventId, categoryId, page }).then((res) => {
      console.log({ res });
      if (res.data.requestStatus === 1) {
        if (res.data?.bookingDetails) {
          res = Object.assign({}, res, {
            data: {
              ...res.data,
              bookingDetails: [
                ...previousSearchData,
                ...res.data.bookingDetails,
              ],
            },
          });
          this.setState({
            eventBookingList: res.data?.bookingDetails,
            nextPage: res.data.paginationData?.next,
            totalPage: res.data.paginationData?.total,
            bookingLoader: false,
            categoryId: categoryId,
          });
        }
      } else {
        toaster.warning(res.data.message);
      }
    });
  };

  findBookingForToday = (bookings) => {
    console.log(this.state.bookingDetails.dateBooked);
    return bookings.find(
      (booking) => booking.dateBooked === this.state.bookingDetails.dateBooked
    );
  };

  handleBookingCheckIn = async (bookingId, id) => {
    let data = {
      bookingId: bookingId,
      id,
    };
    const { bookingDetailsIndex, eventBookingList, bookingDetails } =
      this.state;

    this.props.dispatch(bookingCheckIn(data)).then((res) => {
      if (res.requestStatus === 1) {
        this.props
          .dispatch(
            getBooking({
              bookingId: bookingId,
            })
          )
          .then(() => {
            console.log(this.props.bookingDetails?.bookingDetails);
            this.setState({
              bookingDetails: this.props.bookingDetails.bookingDetails.find(
                (booking) =>
                  booking.dateBooked === this.state.bookingDetails.dateBooked
              ),
            });

            if (this.props.bookingDetails.bookingDetails?.length > 1) {
              if (id !== undefined && id !== null) {
                eventBookingList[bookingDetailsIndex] =
                  this.props.bookingDetails.bookingDetails.find(
                    (booking) =>
                      booking.dateBooked ===
                      this.state.bookingDetails.dateBooked
                  );
              }
            } else {
              eventBookingList[bookingDetailsIndex] =
                this.props.bookingDetails.bookingDetails[0];
            }
          });
      }
    });
  };

  // handlePageChange = async (newPageNum) => {
  //   let { eventId, categoryId, pageNo } = this.state;

  //   this.getBooking(eventId, categoryId, newPageNum);
  // };

  render() {
    let {
      eventList,
      categoryList,
      eventBookingList,
      defaultEventName,
      defaultEventId,
      eventId,
      categoryId,
      defaultCategoryName,
      defaultCategoryId,
      pageNo,
      totalPage,
      bookingLoader,
      bookingDetails,
      bookingStatusIntentMap,
      showBookingDetailsDialog,
      showPage,
    } = this.state;
    console.log({ eventBookingList });
    return showPage ? (
      <Pane
        display={"flex"}
        flexDirection={"column"}
        alignItems={"start"}
        justifyContent={"center"}
        width={"100%"}
      >
        <BackBar title={"Events"} />

        <Pane
          marginTop={16}
          display={"flex"}
          flexDirection={"column"}
          alignItems={"center"}
          width={"100%"}
          justifyContent={"center"}
          height={80}
          gap={10}
        >
          <Select
            width={"90%"}
            value={eventId}
            height={40}
            size={400}
            onChange={(e) => this.getCategoriesByEventId(e)}
          >
            <option value={defaultEventId}>{defaultEventName}</option>
            {eventList.map((event, index) => (
              <option key={index} value={event.id}>
                {event.name}
              </option>
            ))}
          </Select>

          <Select
            // label="sport"
            height={40}
            size={400}
            width={"90%"}
            disabled={categoryList?.length > 0 ? false : true}
            value={categoryId}
            onChange={(e) => this.getEventBooking(e)}
            // disabled={disabled}
          >
            <option value={defaultCategoryId}>{defaultCategoryName}</option>

            {categoryList?.map((category, index) => (
              <option key={index} value={category.id}>
                {category.name}
              </option>
            ))}
          </Select>
        </Pane>
        {eventBookingList &&
          eventBookingList?.map((data, index) => (
            <CustomBookingCard
              customerDetails={data.customerDetails}
              booking={data}
              index={index}
              bookingStatusIntentMap={bookingStatusIntentMap}
              showBookingDetailsDialog={this.showBookingDetailsDialog}
            />
          ))}

        <BookingDetailsDialog
          isShown={showBookingDetailsDialog}
          showDialog={this.showBookingDialog}
          bookingDetails={bookingDetails}
          bookingCheckIn={this.handleBookingCheckIn}
        />

        {/* {eventBookingList && (
            <EventBookingsTable
              handleGetBookingDetails={this.props.handleGetBookingDetails}
              downloadBookings={this.downloadBookings}
              eventBookingList={eventBookingList}
              currentPage={pageNo}
              totalPages={totalPage}
              handlePageChange={this.handlePageChange}
              bookingLoader={bookingLoader}
            />
          )} */}
      </Pane>
    ) : (
      <Pane
        display={"flex"}
        flexDirection="column"
        alignItems={"center"}
        justifyContent={"start"}
        height={400}
      >
        <BackBar title={"Events"} />
        <Pane marginTop={40}> Events Not Available</Pane>
      </Pane>
    );
  }
}

const mapStateToProps = ({
  dashboardData,
  activityData,
  authStatus,
  bookingDetails,
}) => ({
  authStatus,
  dashboardData,
  activityData,
  bookingDetails,
});

export default connect(mapStateToProps)(Event);
